<div *ngFor="let alert of alerts" class="{{ cssClass(alert) }} alert-dismissable">
    {{alert.message}}
    <a class="close" (click)="removeAlert(alert)">&times;</a>
</div>